import EmberService, { service } from '@ember/service';

import moment from 'moment';

import type { Service } from 'webapp-types';
import { hasOccurredWithin24Hours } from 'webapp/utils/common';

import UserPopupInvitePromoBoardComponent from 'webapp/components/user/popup-invite-promo-board';
import UserPopupInvitePromoSourceComponent from 'webapp/components/user/popup-invite-promo-source';

export enum PromoType {
	BOARD = 'board',
	SOURCE = 'source',
}

export default class FlowInviteUsersPromoService extends EmberService {
	@service('popup') declare popupService: Service.Popup;
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('user-settings') declare userSettingsService: Service.UserSettings;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('account') declare accountService: Service.Account;

	get is24HoursAfterAccountCreation() {
		return moment().diff(this.currentUserService.model?.created, 'hours') > 24;
	}

	get showPopup() {
		return (
			!this.popupService.anyPopupsOpen &&
			this.currentUserService.isVerified &&
			this.currentUserService.isAdmin &&
			!this.accountService.isClient &&
			this.mmUsersService.savedRecords.length < 3
		);
	}

	checkToOpenBoardPopup() {
		if (
			this.showPopup &&
			!this.userSettingsService.inviteUserBoardPromoTimestamp &&
			this.mmBoardsService.normalBoardModels.length >= 3 &&
			!hasOccurredWithin24Hours(this.userSettingsService.inviteUserSourcePromoTimestamp)
		) {
			this.openPopup();
		}
	}

	checkToOpenSourcePopup() {
		if (
			this.showPopup &&
			!!this.appNotificationsService.connectSelections.length &&
			this.is24HoursAfterAccountCreation &&
			!this.userSettingsService.inviteUserSourcePromoTimestamp &&
			!hasOccurredWithin24Hours(this.userSettingsService.inviteUserBoardPromoTimestamp)
		) {
			this.openPopup(PromoType.SOURCE);
		}
	}

	openPopup(contentType = PromoType.BOARD) {
		const options = {
			popupClass: 'popup-type-invite-users-promo wizard',
			allowStacked: true, // role select popup
		};
		const popup =
			contentType === PromoType.BOARD
				? this.popupService.createModal(UserPopupInvitePromoBoardComponent, options)
				: this.popupService.createModal(UserPopupInvitePromoSourceComponent, options);
		return popup.open({
			contentType,
		});
	}
}

declare module '@ember/service' {
	interface Registry {
		'flow/invite-users-promo': FlowInviteUsersPromoService;
	}
}
